<template>
  <Layout2
    title="Please enter your mobile number"
    padTop="200px"
  >

    <template slot="form">
      <form @submit.prevent="">
        <div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <v-autocomplete
                v-model="form.countryCode"
                class="form-control fn14 m-0 h52px c_select"
                data-vv-name="countrycode"
                data-vv-as="Country code"
                name = "countrycode"
                v-validate="{required: true}"
                :items= "getCountryNameWithCode"
                item-value= "value"
                item-text= "name"
                placeholder="Country Code*"
                hide-details
              ></v-autocomplete>
              <small class="col_error" v-show="errors.has('countrycode')">{{ errors.first('countrycode') }}</small>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="form-group">
              <input
                type="number"
                id="mobileNumber"
                placeholder="Mobile*"
                class="form-control fn14 h52px"
                v-model="form.mobileNumber"
                v-validate="'required'"
                data-vv-name="mobileNumber"
                data-vv-as="Mobile number"
              />
              <small class="col_error" v-show="errors.has('mobileNumber')">{{ errors.first('mobileNumber') }}</small>
            </div>
          </div>
        </div>
        <p class="col_grey75 fn14 ln_ht20 fw400 mt-2 text-transform-none">{{cloudName}} requires all mobile numbers to be verified</p>
        <div class="mb20 mt20">
          <input type="submit" class="btn btn-apiculus-primary" value="CONTINUE" :disabled="validate"  @click="setMobileNumber()" />
          <!-- <v-btn color="primary" :disabled="!verificationCodeValid" v-if="!(isMobileRequired && emailVerified)" @click="initiateEmailVerification()">Verify Email</v-btn> -->
        </div>
      </form>
    </template>
  </Layout2>
</template>

<script>
import Layout2 from './Layout2.vue'
// import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
import helpers from '../../services/toast-service'

export default {
  name: 'mobileVerification',
  mixins: [helpers],
  data () {
    return {
        form: {},
        data: {},
        color: '',
        message: '',
        cloudName: ''
    }
  },
  components: {
    Layout2
      },
  computed: {
     ...mapGetters({
         getCountryNameWithCode: 'getCountryNameWithCode',
    }),
  },
  mounted () {
    let userDetails = this.$route.params
    if (!(Object.keys(userDetails).length > 0)) {
      this.$router.push('/signup')
    } else {
      this.data = userDetails
      this.form.email = userDetails.email
    }
  },
  methods: {
      setMobileNumber() {
          this.$validator.validateAll().then((result) => {
        if (result) {
            this.form.countryCode = this.form.countryCode.split('+')[1]
            this.$store.dispatch('ACTION_VALIDATE_MOBILE',this.form).then(res=>{
                if(res.success) {
                    let obj = { ...this.data, mobileVerified: true, emailVerified: true,MobileData: this.form }
                    this.$router.push({ name: 'mobileOTPVerification', params: obj })
                }
                else {
                    this.toastAlert(res.error.message || 'Something went wrong.', 'error')
                }
            })
        }
        else {
            this.toastAlert('Fill all details', 'error')
        }
        })
      }
},
created () {
    this.$store.dispatch('ACTION_GET_COUNTRY_NAME')
    this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
      if (res) {
        this.cloudName = res.name
      }
    })
}
}
</script>

<style scoped>
.c_select>.v-input__control>.v-input__slot:before { 
  border-style: none; 
} 
.c_select>.v-input__control>.v-input__slot:after { 
  border-style: none; 
}

</style>
